import React, { useState, useEffect } from 'react';

const Argitech2 = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePlayClick = () => {
    setShowVideo(true);
  };

  return (
    <div className='bg-white'>
      <div className='px-4 md:px-40 pt-3'>
        <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
        <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

        <div className="relative w-full overflow-hidden rounded-lg bg-white">
          <div className="relative w-full rounded-lg">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
              </div>
            )}
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744553587/image-1_kma4ur.png"
              alt="Securing Agriculture in Namibia"
              className={`w-full md:h-[622px] object-cover rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
              onLoad={() => setIsLoading(false)}
            />
            
            {/* Play Button */}
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
              alt="Play"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-20 cursor-pointer"
              onClick={handlePlayClick}
            />

            {/* Video Overlay */}
            {showVideo && (
              <div className="absolute inset-0 flex items-center justify-center z-30">
                <video
                  src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744505363/WhatsApp_Video_2025-04-13_at_5.16.54_AM_tguh1v.mp4"
                  controls
                  className="w-full h-full object-cover rounded-lg"
                ></video>
              </div>
            )}

            {/* Text Content */}
            {!isLoading && !showVideo && (
              <div className="absolute md:bottom-2 bottom-6 md:left-0 w-full px-2 z-10">
                <h2 className="text-black text-[12px] md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2 className="text-black text-[14px] md:text-[40px] font-bold -mt-3" style={{ lineHeight: '1.20' }}>
                  Innovation for Sustainable <br /> Future
                </h2>
              </div>
            )}
          </div>
        </div>

        <div className='px-1'>
  <div className="mt-5 max-w-screen-xl w-full">
    <h3 className="text-black font-normal text-[14px] md:text-[30px]">April 13, 2025</h3>
    <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
      <p>Story by Editorial team</p>
      <div className="flex items-center gap-2 text-[#155528]">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
          alt="Clock"
          className="h-6 w-6 md:h-8 md:w-8"
        />
        <p>2 Minutes read</p>
      </div>
    </div>
  </div>

  <h3 className="text-black font-bold text-[10px] md:text-[36px] mt-3 md:mt-5">The Promise of Agricultural Technology</h3>

  <div className="md:mt-5 mt-2 md:space-y-10 space-y-5">
    <p className="md:text-[32px text-[8px] text-black font-normal">
      Agriculture has always been the backbone of African economies, providing sustenance, employment, and cultural identity.
      However, as we stand at the crossroads of tradition and modernity, it is imperative that we harness the tools of the 21st century to propel our agricultural practices forward.
    </p>

    <p className="text-[24px] text-black font-normal">
      <strong>Agricultural technology</strong>—from precision farming and climate-smart techniques to digital platforms and data analytics—holds the key to unlocking unprecedented levels of productivity and sustainability.
      In Namibia, we have already witnessed the transformative power of such technologies. The adoption of conservation agriculture practices has led to increased yields and improved food security for many farmers.
    </p>

    <p className="text-[24px] text-black font-normal">
      <strong>Imagine a future where every Namibian farmer has access to real-time weather updates, soil health monitoring, and market prices at their fingertips.</strong>
      Picture a scenario where our youth are not fleeing to urban centers but are instead returning to the land, equipped with drones, sensors, and apps that make farming both profitable and prestigious.
      This is not a distant dream but an achievable reality if we commit to embracing agricultural technology.
    </p>

    <p className="text-[24px] text-black font-normal">
      A Call to Action: <strong>Let's Go Namibia!</strong><br />
      But technology alone is not enough. We need a movement—a collective will to change the narrative of African agriculture.
      This movement begins with us, here and now. As we launch the <strong>Farmers' Network</strong>, let it be a <strong>beacon of hope, collaboration, and innovation.</strong>
    </p>

    <p className="text-[24px] text-black font-normal">
      <strong>Let's Go Namibia!</strong> Let's lead by example, showing the world that with determination, unity, and the right tools,
      we can transform our agricultural sector. Let's inspire our neighbouring countries to join us on this path, creating a ripple effect that will touch every corner of Africa.
    </p>

    <p className="text-[24px] text-black font-normal">
      <strong>The Pan-African Vision</strong><br />
      Our vision extends beyond the borders of Namibia. Across the continent, countries are recognizing the potential of agricultural technology to drive economic growth and food security.
      Initiatives are underway to triple fertilizer use to restore soil health and boost food production.
      From the plains of Ethiopia to the savannas of Kenya, farmers are adopting new technologies that are revolutionizing their yields and livelihoods.
    </p>

    <p className="text-[24px] text-black font-normal">
      As Africans, we are uniquely positioned to lead a new <strong>Green Revolution</strong>—one that is sustainable, inclusive, and technologically advanced.
      Our young population, our vast arable lands, and our rich traditions provide a solid foundation upon which to build this future.
    </p>

    <p className="text-[24px] text-black font-normal">
      In closing, let us remember that the journey of a thousand miles begins with a single step. Today, we take that step together. Let us commit to:
    </p>

    <ul className="list-disc list-outside pl-5 text-[24px] text-black font-normal space-y-3">
      <li><strong>Empowering our farmers through education and access to technology.</strong></li>
      <li><strong>Building infrastructures that support innovation and market access.</strong></li>
      <li><strong>Fostering partnerships that bridge the gap between research, policy, and practice.</strong></li>
      <li><strong>Celebrating our successes and learning from our challenges.</strong></li>
    </ul>

    <p className="text-[24px] text-black font-normal mt-5">
      <strong>Let's Go Namibia!</strong> Let us lead the way in transforming African agriculture for the betterment of all.
    </p>

    <p className="text-[24px] text-black font-normal">Thank you.</p>

    <div className='md:h-5 h-2'></div>
  </div>
</div>

      </div>
    </div>
  );
};

export default Argitech2;
